import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'
import UrlBuilder from 'app/utils/UrlBuilder'
import { generateDownloadFileName, downloadFile } from 'app/utils/utils';
import { set } from 'lodash';

const initialState = {    
    item : {
        ern_items: [],
        non_exist_stock: []        
    },
    report: null,
    status: HTTP_STATUS.IDLE,
    invoiceStatus: HTTP_STATUS.IDLE,
    reportStatus: HTTP_STATUS.IDLE
}

export const fetchErnInvoice = createAsyncThunk('ern/get-invoice', async ({id, data}, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().searchQuery(data).filter(data, 'fileType').filter(data, 'stDate').filter(data, 'enDate').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Expire/generate-invoice/${id}${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
    
})

export const createErn = createAsyncThunk('ern/create', async (postdata = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Expire', postdata)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const Ern = createSlice({
    name: 'ern',
    initialState,
    reducers: {
        setErnItems: (state, action) => {
            state.item.ern_items.push(action.payload);
        },
        setNonExistStock: (state, action) => {
            state.item.non_exist_stock = action.payload;
        },
        resetNonExistStock: (state, action) => {
            state.item.non_exist_stock = [];
        },
        setGrnItemList: (state, action) => {
            state.item.ern_items = action.payload;
        },
        removeItemFromErn: (state, action) => {
            state.item.ern_items.splice(action.payload, 1);
        },
        setResellingPrice: (state, action) => {
            state.item.ern_items[action.payload.rowIndex].reselling_price = action.payload.reselling_price
        },
        resetErn: (state, action) => {
            return initialState;
        },
        resetErnWithoutItem: (state, action) => {
            state.report = initialState.report
            state.status = initialState.status
            state.reportStatus = initialState.reportStatus
        }
    },
    extraReducers(builder) {
        builder
            .addCase(createErn.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(createErn.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createErn.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchErnInvoice.pending, (state, action) => {
                state.reportStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchErnInvoice.fulfilled, (state, action) => {
                state.reportStatus = HTTP_STATUS.SUCCEEDED
                state.report = action.payload
            })
            .addCase(fetchErnInvoice.rejected, (state, action) => {
                state.reportStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getErn = (state) => state.ern.item;
export const getErnStatus = (state) => state.ern.status;
export const getErnReportStatus = (state) => state.ern.reportStatus;
export const getErnReport = (state) => state.ern.report;

export const ernActions = Ern.actions

export default Ern.reducer